import {
    colors,
    fontSizes,
    fontWeights,
} from "@gumtree/ui-library/src/base/theme";

export const NavBarButtonOverride = `
    padding: 0;
    font-size: ${fontSizes.smaller};
    font-weight: ${fontWeights.normal};
    transition: 0.1s ease;
`;

export const MhhNavBarButtonOverride = `
    width: 32px;
    min-width: 32px;
    height: 42px;
    justify-content: flex-start;
    align-items: center;
    border: 0;
    color: ${colors.white};
    font-family: "Readex Pro", sans-serif;
    font-size: ${fontSizes.xsmall};
    font-weight: ${fontWeights.normal};
    line-height: 18px;
    letter-spacing: 0;

    &:hover,
    &:active {
        color: ${colors.white};
    }

    > [aria-hidden="true"] {
        width: 24px;
        height: 24px;
        margin-bottom: 0;
        color: ${colors.white};
        font-size: 24px;
    }
`;

export const MhhNavBarIconOverride = `
    width: 24px;
    height: 24px;
    margin-bottom: 0;
    color: ${colors.white};
    font-size: 24px;
`;
